import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import axios from 'axios';
import toast from 'react-hot-toast';
import { useAuth } from '../../auth/context/AuthContext';

export default function ProfilePage() {
  const { user, logout } = useAuth();
  const [form, setForm] = useState({ phone: user?.phone || '', password: '', confirm: '' });
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const save = async () => {
    if (form.password && form.password !== form.confirm) return toast.error('Passwords do not match');
    setLoading(true);
    try {
      await axios.put('/api/customer/profile', { phone: form.phone, password: form.password || undefined });
      toast.success('Profile updated');
    } catch { toast.error('Update failed'); }
    finally { setLoading(false); }
  };

  return (
    <div>
      <div className="page-header">
        <Link to="/home" className="back-btn">←</Link>
        <h1>My Profile 👤</h1>
      </div>
      <div className="page-content">
        <div className="card" style={{ textAlign: 'center', background: 'linear-gradient(135deg, #1A6B8A, #0e4d6b)', color: 'white' }}>
          <div style={{ width: 64, height: 64, borderRadius: '50%', background: 'rgba(255,255,255,0.2)', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 32, margin: '0 auto 10px' }}>👤</div>
          <p style={{ fontWeight: 800, fontSize: 18 }}>{user?.full_name}</p>
          <p style={{ opacity: 0.8, fontSize: 13 }}>{user?.email}</p>
          <p style={{ marginTop: 8, background: 'rgba(255,255,255,0.2)', borderRadius: 20, padding: '4px 14px', display: 'inline-block', fontSize: 13, fontWeight: 700 }}>{user?.shipping_mark}</p>
        </div>

        <div className="card">
          <p style={{ fontWeight: 700, marginBottom: 12 }}>Update Phone</p>
          <div className="input-group">
            <label>Phone Number</label>
            <input className="input-field" type="tel" value={form.phone} onChange={e => setForm({...form, phone: e.target.value})} />
          </div>
        </div>

        <div className="card">
          <p style={{ fontWeight: 700, marginBottom: 12 }}>Change Password</p>
          <div className="input-group">
            <label>New Password</label>
            <input className="input-field" type="password" placeholder="Leave blank to keep current" value={form.password} onChange={e => setForm({...form, password: e.target.value})} />
          </div>
          <div className="input-group">
            <label>Confirm Password</label>
            <input className="input-field" type="password" placeholder="Repeat new password" value={form.confirm} onChange={e => setForm({...form, confirm: e.target.value})} />
          </div>
        </div>

        <button className="btn btn-primary btn-full" onClick={save} disabled={loading}>
          {loading ? <span className="spinner" /> : 'Save Changes'}
        </button>

        <button onClick={() => { logout(); navigate('/'); }} className="btn btn-danger btn-full" style={{ marginTop: 10 }}>
          🚪 Sign Out
        </button>
      </div>
    </div>
  );
}
